if (!customElements.get('custom-swiper')) {
  customElements.define(
    'custom-swiper',
    class CustomSwiper extends HTMLElement {
      constructor() {
        super();
        this.thumbsSwiper = null;
        this.mainSwiper = null;
        this.handleResize = this.handleResize.bind(this);
      }

      connectedCallback() {
        this.desktopMode = this.getAttribute("data-desktop") === "true"; 
        this.updateSwiperState();
        window.addEventListener("resize", this.handleResize);
      }

      disconnectedCallback() {
        window.removeEventListener("resize", this.handleResize);
        this.destroySwipers();
      }

      handleResize() {
        this.updateSwiperState();
      }

      updateSwiperState() {
        const isDesktop = window.matchMedia("(min-width: 960px)").matches;
        const shouldInit = (this.desktopMode && isDesktop) || (!this.desktopMode && !isDesktop);

        if (shouldInit) {
          if (!this.mainSwiper) this.initSwipers();
        } else {
          this.destroySwipers();
        }
      }

      initSwipers() {
        const thumbsEl = this.querySelector("[data-thumbnails-swiper]");
        thumbsEl.classList.remove('hidden');
        const mainEl = this.querySelector("[data-main-swiper]");
        if (!thumbsEl || !mainEl) return;

        // Add Swiper container classes
        thumbsEl.classList.add("swiper");
        mainEl.classList.add("swiper");

        //Add wrappper
        thumbsEl.querySelector('.wrapper').classList.add('swiper-wrapper');
        mainEl.querySelector('.wrapper').classList.add('swiper-wrapper');

        // Add slide classes to each child
        thumbsEl.querySelectorAll(".product-thumbs-slide").forEach(el => el.classList.add("swiper-slide"));
        mainEl.querySelectorAll(".product-main-slide").forEach(el => el.classList.add("swiper-slide"));

        this.thumbsSwiper = new Swiper(thumbsEl, {
          spaceBetween: 8,
          slidesPerView: "auto",
          freeMode: true,
          watchSlidesProgress: true,
        });

        this.mainSwiper = new Swiper(mainEl, {
          spaceBetween: 8,
          slidesPerView: 1,
          navigation: {
            nextEl: this.querySelector(".product-media__button-next"),
            prevEl: this.querySelector(".product-media__button-prev"),
          },
          thumbs: {
            swiper: this.thumbsSwiper,
          },
        });
      }

      destroySwipers() {
        if (this.mainSwiper) {
          this.mainSwiper.destroy(true, true);
          this.mainSwiper = null;
        }
        if (this.thumbsSwiper) {
          this.thumbsSwiper.destroy(true, true);
          this.thumbsSwiper = null;
        }

        // Remove Swiper classes
        const thumbsEl = this.querySelector("[data-thumbnails-swiper]");
        thumbsEl.classList.add('hidden');
        const mainEl = this.querySelector("[data-main-swiper]");

        if (thumbsEl) {
          thumbsEl.querySelector('.wrapper').classList.remove('swiper-wrapper');
          thumbsEl.classList.remove("swiper");
          thumbsEl.querySelectorAll(".product-thumbs-slide").forEach(el => el.classList.remove("swiper-slide"));
        }

        if (mainEl) {
          mainEl.querySelector('.wrapper').classList.remove('swiper-wrapper');
          mainEl.classList.remove("swiper");
          mainEl.querySelectorAll(".product-main-slide").forEach(el => el.classList.remove("swiper-slide"));
        }
      }

      refresh() {
        this.destroySwipers();
        this.updateSwiperState();
      }

    }
  );
}
